import { render } from "./PdfLearningViewer.vue?vue&type=template&id=e905f744&scoped=true"
import script from "./PdfLearningViewer.vue?vue&type=script&lang=js"
export * from "./PdfLearningViewer.vue?vue&type=script&lang=js"

import "./PdfLearningViewer.vue?vue&type=style&index=0&id=e905f744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e905f744"]])

export default __exports__